'use client'

import React from 'react'
import { Divider, Stack, Text, Title } from '@mantine/core'
import '@mantine/carousel/styles.css'
import { isMobile } from 'react-device-detect'
import StoreCarousel from '@/components/Store/StoreCarousel'
import { ServiceItemCardType } from '@/types/enums/ServiceItem'
import { useRenderedServices } from '@/hooks/useRenderedServices'
import { PageLocation } from '@nile/mantine-theme/analytics'

function MoreFromGeneralMedicine({
    title = 'More from General Medicine',
    subtitle = 'Same-day virtual care for hundreds of health needs.',
    skuId,
    skuName,
}: {
    title?: string
    subtitle?: string
    skuId: string
    skuName: string
}) {
    const { services, loading } = useRenderedServices()

    return (
        !loading &&
        services.length > 0 && (
            <Stack gap={24}>
                {!isMobile ? renderWebHeader() : renderMobileHeader()}
                {!isMobile && <Divider bd={'1px solid var(--gm-foreground-fg-outline-primary)'} />}
                {renderCarousel()}
            </Stack>
        )
    )

    function renderMobileHeader() {
        return (
            <Text
                c={'var(--Foreground-fg-primary, #1F1E1D)'}
                fz={36}
                fw={'var(--gm-weight-display-small, 450)'}
                lh={'130%'}
                lts={'-0.24px'}
                flex={'1 0 0'}
            >
                {title}
            </Text>
        )
    }

    function renderWebHeader() {
        return (
            <Stack gap={16}>
                <Title order={2} fz={48} fw={400} lh={'100%'} lts={'-1.08px'} c={'var(--GM-Text-Black, #181818)'}>
                    {title}
                </Title>
                <Text fz={24} fw={500} lh={'120%'} lts={'-1.08px'} c={'var(--GM-Text-Black, #181818)'}>
                    {subtitle}
                </Text>
            </Stack>
        )
    }

    function renderCarousel() {
        return (
            <StoreCarousel
                cardType={ServiceItemCardType.serviceItem}
                services={services[0].services}
                pageLocation={PageLocation.DETAIL_PAGE}
                additionalInformation={{ sku_id: skuId, sku_name: skuName }}
            />
        )
    }
}

export default MoreFromGeneralMedicine
